/* eslint-disable */
import React, { useState } from 'react';
import ProjectImage1 from '../../assets/project1.png';
import ProjectImage2 from '../../assets/project2.png';
import ProjectImage3 from '../../assets/Screenshot 2023-02-24 124728.png';
import ProjectImage4 from '../../assets/project4.png';
import ProjectImage5 from '../../assets/project5.png';
import ProjectImage6 from '../../assets/project6.png';
import ProjectImage7 from '../../assets/Portfolio website.png';
import './portfolio.css';

const data = [
  {
    id: 1,
    title: 'DRC 145 Territories Development Conference',
    subtitle:
      ' Rennes, France, from October 28th to 30th, 2023: RDC, EKOLO MAKASI—an international conference on the development of 145 territories in the Democratic Republic of Congo, uniting Congolese diaspora and nationals to foster their countrys strength through entrepreneurship and the third sector.',
    image: ProjectImage6,
    seeproject:
      'https://rdc145territoires.com/',
    seesource:
      'https://github.com/Pamphilemkp/145-territoires-rdc.git',
  },
  {
    id: 2,
    title: 'Portfolio-Website',
    subtitle:
      ' Delivered a stunning portfolio website that showcases Arnel’s professionalism',
    image: ProjectImage7,
    seeproject:
      'https://basitali111.github.io/Arnel-Kabangu-Bayile-Portfolio/',
    seesource:
      'https://github.com/basitali111/Arnel-Kabangu-Bayile-Portfolio',
  },
  {
    id: 3,
    title: 'British-Classic-Meals',
    subtitle:
      ' This App is about British Food where you find a list of meals that you can like and comment.',
    image: ProjectImage1,
    seeproject:
      'https://tiagomarin.github.io/British-Classic-Meals/',
    seesource:
      'https://github.com/basitali111/British-Classic-Meals',
  },
  {
    id: 4,
    title: 'ToDo-List',
    subtitle:
      'This project contains a to-do list project where tasks can be added, marked as completed, and deleted. Users can edit a task by double-clicking on the task title section. A task can be deleted by clicking on the trash can icon on the right side of each task. Tasks can be marked as completed by clicking on the corresponding checkbox. All complete',
    image: ProjectImage2,
    seeproject:
      'https://basit-todolist.netlify.app/',
    seesource:
      'https://github.com/basitali111/ToDo-List',
  },
  {
    id: 5,
    title: 'Global Summit 2015',
    subtitle:
      ' This is a capstone project for HTML/CSS module in Microverse. The project is built for a web development CSS that takes place every year in different locations and cities. Users can sign up to attend the event.',
    image: ProjectImage3,
    btn1: 'html',
    btn2: 'css',
    btn3: 'react',
    seeproject:
      'https://basitali111.github.io/first-capstone-project-/',
    seesource:
      'https://github.com/basitali111/first-capstone-project-',
  },
  {
    id: 6,
    title: 'Online-Shopping-Store',

    subtitle:
      " online-shiopping-store - A web application based on an external API which contains information about items for sell. The web app allows the user to view one page with a list of items that could be filtered by some parameters. It's a list of metrics that can be filtered by each specific item on sell. It also shows one page for the item details",
    image: ProjectImage4,
    seeproject:
      'https://deploy-preview-1--basit-online-shopping.netlify.app/',
    seesource:
      'https://github.com/basitali111/online-shiopping-store',
  },
  {
    id: 7,
    title: 'Math-magicians',

    subtitle:
      'Math-Magician is a web app for all lovers of mathematics. It is a Single Page Application (SPA) that allows users to make simple calculations and read a random math-related quotes.',
    image: ProjectImage5,
    seeproject:
      'https://basit-math.netlify.app/calculator',
    seesource:
      'https://github.com/basitali111/Math-magicians-',
  },
];
const Portfolio = () => {
  const [toggleState, setToggleState] = useState(0);
  const [indexState, setIndexState] = useState(0);

  const toggleTab = (open, id) => {
    setToggleState(open);
    setIndexState(id);
  };

  return (
    <section id="portfolio">
      <h2 className="section_title">My Portfolio</h2>
      <span className="section_subtitle">Recent Works</span>
      <div className="container portfolio_contianer">
        {
            data.map(({
              id, title, subtitle, image, seeproject, seesource,
            }) => (
              <article key={id} className="portfolio_item">
                <div className="card-container">
                  <div className="portfolio_item-image">
                    <img src={image} alt={title} className="project_image" />
                  </div>
                  <h3>{title}</h3>
                  <span role="button" className="portfolio_button" onClick={() => toggleTab(1, id)}>
                    View more
                    {' '}
                    <i className="uil uil-arrow-right portfolio_button-icon" />
                  </span>
                </div>
                <div className={toggleState === 1 && indexState === id ? 'portfolio_modal active_portfolio' : 'portfolio_modal'}>
                  <div className="portfolio_modal-content">
                    <i onClick={() => toggleTab(0, id)} className="uil uil-times portfolio_modal-close" />
                    <div className="pop-up-contianer">
                      <div className="portfolio_modal-image">
                        <img src={image} alt={title} className="popup_image" />
                      </div>
                      <div className="description">
                        <div>
                          <p className="portfolio_modal-title">{subtitle}</p>
                        </div>
                        <div className="buttons">
                          <div>
                            {' '}
                            <a href={seeproject} className="demo-btn">Demo</a>
                          </div>
                          <div>
                            {' '}
                            <a href={seesource} className="btn button--flex">
                              Github
                              <svg
                                className="button__icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M14.2199 21.9352C13.0399 21.9352 11.3699 21.1052 10.0499 17.1352L9.32988 14.9752L7.16988 14.2552C3.20988 12.9352 2.37988 11.2652 2.37988 10.0852C2.37988 8.91525 3.20988 7.23525 7.16988 5.90525L15.6599 3.07525C17.7799 2.36525 19.5499 2.57525 20.6399 3.65525C21.7299 4.73525 21.9399 6.51525 21.2299 8.63525L18.3999 17.1252C17.0699 21.1052 15.3999 21.9352 14.2199 21.9352ZM7.63988 7.33525C4.85988 8.26525 3.86988 9.36525 3.86988 10.0852C3.86988 10.8052 4.85988 11.9052 7.63988 12.8252L10.1599 13.6652C10.3799 13.7352 10.5599 13.9152 10.6299 14.1352L11.4699 16.6552C12.3899 19.4352 13.4999 20.4252 14.2199 20.4252C14.9399 20.4252 16.0399 19.4352 16.9699 16.6552L19.7999 8.16525C20.3099 6.62525 20.2199 5.36525 19.5699 4.71525C18.9199 4.06525 17.6599 3.98525 16.1299 4.49525L7.63988 7.33525Z"
                                  fill="var(--container-color)"
                                />
                                <path
                                  d="M10.11 14.7052C9.92005 14.7052 9.73005 14.6352 9.58005 14.4852C9.29005 14.1952 9.29005 13.7152 9.58005 13.4252L13.16 9.83518C13.45 9.54518 13.93 9.54518 14.22 9.83518C14.51 10.1252 14.51 10.6052 14.22 10.8952L10.64 14.4852C10.5 14.6352 10.3 14.7052 10.11 14.7052Z"
                                  fill="var(--container-color)"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))
          }
      </div>
    </section>
  );
};

export default Portfolio;
